import { buttonSizeData } from '~button';
var radioButtonGroupSizeData = buttonSizeData;
export default radioButtonGroupSizeData;